import { PropsWithChildren } from "react"
import './PageSidebar.css'

const PageSidebar = (props: PropsWithChildren) => {
  return <>
    <div className="page-sidebar">
      {props.children}
    </div>
  </>
}

export default PageSidebar
